import CategoryPage from '../components/CategoryPage';

export default function Courses() {
  return <CategoryPage type="course" title="Courses" />;
}
